import React, { useState, useEffect, useContext, useRef } from "react";
import { useParams } from "react-router-dom";
import { DataGrid, gridClasses } from "@mui/x-data-grid";

import { Link, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import FormControlLabel from "@mui/material/FormControlLabel";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import styled from "styled-components";

import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";

import {
  EDIT_CLIENT_MUTATION,
  GET_CLIENT_DATA_BY_NAME,
  GET_CLIENT_DATA_BY_ID,
} from "../../graphQL/client_qry";
import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";
import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14, //16,
    fontFamily: "Arial",
    paddingLeft: 5,
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    width: "100%",
    "& .super-app-theme--header": {
      backgroundColor: "#0D47A1",
      color: "white",
      fontSize: 18,
      fontWeight: 700,
    },
    "& .MuiDataGrid-cell": {
      fontSize: 16,
      fontWeight: 400,
    },
    "& .MuiDataGrid-columnHeader .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "none !important",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "none !important",
    },
    "& .MuiDataGrid-cell:focus-within": {
      outline: " none !important",
    },
    // "& .style--true": {
    //   backgroundColor: "#FFFFFF",
    // },
    // "& .style--false": {
    //   backgroundColor: "#E2EDF5", //#E3F2FD",
    // },
    [`& .${gridClasses.row}.even`]: {
      backgroundColor: "#FFFFFF",
    },
    [`& .${gridClasses.row}.odd`]: {
      backgroundColor: "#E2EDF5",
    },
    [`& .${gridClasses.row}.even:hover`]: {
      backgroundColor: "#FFFFFF",
    },
    [`& .${gridClasses.row}.odd:hover`]: {
      backgroundColor: "#E2EDF5",
    },
    [`& .${gridClasses.row}.even.Mui-selected`]: {
      backgroundColor: "#FFFFFF !important",
    },
    [`& .${gridClasses.row}.odd.Mui-selected`]: {
      backgroundColor: "#E2EDF5 !important",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  datePickerStyle: {
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
}));

function ClientEdit() {
  const { clientUuid } = useParams();

  const tenantName = localStorage.getItem("tenantName");
  const tenantId = localStorage.getItem("tenantId");

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");

  const [loadContent, setLoadContent] = useState(false);
  const [errorMsg, setErrorMsg] = useState({
    name: "",
    noOfWeeks: "",
    termStartDate: "",
  });

  const [clientName, setClientName] = useState("");
  const [termNoOfWeeks, setTermNoOfWeeks] = useState("");
  const [termStartDate, setTermStartDate] = useState("");
  const [alertMsg, setAlertMsg] = useState([]);
  const [clientData, setClientData] = useState([]);

  const classes = useStyles();
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
    
  const [editAccess, setEditAccess] = useState(true);

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [getClientData] = useManualQuery(GET_CLIENT_DATA_BY_ID, {
    fetchPolicy: "network-only",
  });

  const [editClient] = useMutation(EDIT_CLIENT_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [getClientDataByName] = useManualQuery(GET_CLIENT_DATA_BY_NAME, {
    fetchPolicy: "network-only",
  });

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "Clients",
              modulepageName: "List"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {  
        
            
      let commonActions = accessData.staffModuleAccess.commonActions.split('|');
      
      
      if(commonActions.find(a => a == "Edit")){
        setEditAccess(true);}
      else {setEditAccess(false);}


      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

   useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);

  const getClient = async () => {
    if (clientUuid) {
      // Get terclientm information
      const {
        loading: clientDataLoading,
        error: clientDataError,
        data: clientData,
      } = await getClientData({
        variables: { clientUuid: clientUuid },
      });

      
      if (clientData.getClientDataByID == null)
      {
        navigate(`${project_url}/tenant/dashboard`)
      }

      else if (!clientDataLoading && clientData && clientData.getClientDataByID) {

        setClientData(clientData.getClientDataByID);
        setClientName(clientData.getClientDataByID.name);
        setTermNoOfWeeks(clientData.getClientDataByID.termNoOfWeeks);
        setTermStartDate(dayjs(clientData.getClientDataByID.termStartDate));
      }
      if (
        clientDataError &&
        clientDataError.graphQLErrors &&
        clientDataError.graphQLErrors[0].message === "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      }
      
    }
  };

  const handleClientNameChange = e => {
    setClientName(e.target.value);
    if (e.target.value.toString().trim() === "") {
      setErrorMsg({ ...errorMsg, name: "Client Name cannot be blank." });
    } else {
      setErrorMsg({ ...errorMsg, name: "" });
    }
  };

  const handleStartDateChange = date => {
    setTermStartDate(date);
    let sDate = new Date(date).toLocaleDateString("sv-SE");
    if (!termStartDate || sDate == "") {
      setErrorMsg({ ...errorMsg, termStartDate: "Start Date cannot be blank." });
    } else if (sDate == "Invalid Date") {
      setErrorMsg({ ...errorMsg, termStartDate: "Start Date is invalid." });
    } else {
      setErrorMsg({ ...errorMsg, termStartDate: "" });
    }
  };

  const validateNoOfWeeks = value => {
    setTermNoOfWeeks(parseInt(value));
    if (parseInt(value) < 1) {
      setErrorMsg({ ...errorMsg, noOfWeeks: "Enter an integer greater than zero." });
    } else if (parseInt(value) > 99) {
      setErrorMsg({ ...errorMsg, noOfWeeks: "Enter an integer less than 100." });
    } else if (value.toString().trim() === "") {
      setErrorMsg({ ...errorMsg, noOfWeeks: "No of Weeks cannot be blank." });
    } else {
      setErrorMsg({ ...errorMsg, noOfWeeks: "" });
    }
  };

  useEffect(() => {
    (() => getClient())();
  }, [clientUuid]);

  const onSubmit = async formData => {
    let sDate = new Date(termStartDate).toLocaleDateString("sv-SE");
    if (!termStartDate || sDate == "" || sDate == "Invalid Date") {
      return;
    }

    //check if entered name exist in tenant or not
    const {
      loading: clientLoading,
      error: clientError,
      data: clientData,
    } = await getClientDataByName({
      variables: {
        name: formData.clientName,
        tenantId: parseInt(tenantId),
        clientUuid: clientUuid,
      },
    });

    if (!clientLoading && clientData && clientData.getClientDataByName) {
      setErrorMsg({
        ...errorMsg,
        name: "This name has been exist in tenant, please enter another name.",
      });
    } else {
      setErrorMsg({});
      const { data, error } = await editClient({
        variables: {
          name: formData.clientName,
          clientUuid: clientUuid,
          termStartDate: sDate,
          termNoOfWeeks: parseInt(termNoOfWeeks),
        },
      });
      if (error) {
        console.log("Error", error, data);
        setAlertMsg({
          title: "Error",
          msg: "Unfortunately an error occurred.",
        });
      } else if (data && data.editClient) {
        console.log("Success", data);
        setAlertMsg({
          title: "Success",
          msg: "Client has been successfully updated.",
        });
      }
    }
  };
  
  if (loadContent)
    if (editAccess)
    return (
      <div className={classes.root}>
        <Header breadcrumbs={[{ label: clientData.name, link: null }]} />
        <div className={classes.container}>
          <Box mt={2} mb={2} textAlign="center">
            <Typography variant="body1" style={{ marginBottom: 10 }}>
              Clients Edit
            </Typography>
          </Box>
          <Divider />

          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid
              container
              spacing={3}
              style={{
                marginTop: 30,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Grid item xs={4}>
                <TextField
                  className={classes.textFieldStyle}
                  fullWidth
                  label="Client Name"
                  margin="normal"
                  name="clientName"
                  type="clientName"
                  variant="outlined"
                  value={clientName}
                  id="clientName"
                  {...register("clientName", { required: true })}
                  onChange={handleClientNameChange}
                />
                {errorMsg.name && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.name}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={4}>
                <TextField
                  className={classes.textFieldStyle}
                  fullWidth
                  label="Term No of Weeks"
                  margin="normal"
                  name="weeks"
                  type="number"
                  value={termNoOfWeeks}
                  variant="outlined"
                  onKeyDown={e => {
                    if (e.keyCode >= 65 && e.keyCode <= 90) {
                      e.preventDefault();
                    }
                  }}
                  id="weeks"
                  {...register("weeks", { required: true })}
                  onChange={e => validateNoOfWeeks(e.target.value)}
                  InputProps={{
                    inputProps: { min: 1, max: 99, pattern: "^[1-9][0-9]?$" },
                  }}
                />
                {errorMsg.noOfWeeks && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.noOfWeeks}
                  </FormHelperText>
                )}
              </Grid>
              <Grid
                item
                xs={4}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginTop: 15,
                }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className={classes.datePickerStyle}
                    value={dayjs(termStartDate)}
                    label="Term Start Date"
                    id="startDate"
                    name="startDate"
                    onChange={newDate => handleStartDateChange(newDate)}
                  />
                </LocalizationProvider>
                {errorMsg.termStartDate && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.termStartDate}
                  </FormHelperText>
                )}
              </Grid>
            </Grid>
            <Box pt={4} pb={2}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 2 }}
                type="submit"
              >
                Save
              </Button>

              <Button
                variant="text"
                color="primary"
                className={classes.outlinedButtonStyle}
                onClick={() => navigate(`${project_url}/clients`)}
              >
                Cancel
              </Button>
            </Box>
          </form>
          {alertMsg.msg && (
            <AlertDialog
              title={alertMsg.title}
              contentMsg={alertMsg.msg}
              closeDialog={() => {
                setAlertMsg([]);
                alertMsg.title === "Success" && navigate(`${project_url}/clients`);
              }}
            />
          )}
        </div>
      </div>
    );
   else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      ); 
  else return;
  
}

export default ClientEdit;
